import React, { useEffect, useState } from "react";
// import logo from "../assets/logoMusicart.png";
import TextBox from "../components/TextBox";
import "../styles/login.css";
import Loader from "../components/Loader";
import { loginUser } from "../api/service";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/UserContext";
import axios from "axios";
// import { MouseParallax, ScrollParallax } from "react-just-parallax";
/*
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
*/
// const googleTranslateElementInit = () => {
//   new window.google.translate.TranslateElement(
//     {
//       pageLanguage: "en",
//       autoDisplay: false
//     },
//     "google_translate_element"
//   );
// };
const Login = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [invalidflag, setInvalidFlag] = useState(false);
  const navigate = useNavigate();
  const { setUserAuth } = React.useContext(AuthContext);
  const auth = localStorage.getItem("token");


  const login = async (event) => {
    event.preventDefault();
    // Activate the loader
    setLoader(true);
    // Create a new user
    if (email !== "" && password !== "") {
      setLoader(false);
      const user = {
        email: email,
        password: password,
      };
      setEmail("");
      setPassword("");
      await loginUser(user)
        .then((req, res) => {
          const { status, message } = req.data;
          if (status === "failed") {
            setInvalidFlag(true);
          } else {
            localStorage.setItem("token", req.data.token);
            setUserAuth(true);
            navigate("/home");
          }
        })
        .catch((err) => alert(err));
    } else {
      setLoader(false);
      alert("All fields are mandatory!");
    }
  };

  
  const gauth=()=>{ 
    window.open(`${process.env.REACT_APP_API_BASE_URL}/auth/google/callback`,"_self")
  }
  
  const [user, setUser] = useState(null);

  useEffect(() => {
    console.log("calling")
    const getUser =() => {
      fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/login/success`, {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
        },
      })
        .then((response) => {
          if (response.status === 200) return response.json();
          throw new Error("authentication has been failed!");
        })
        .then(async (resObject) => {
          setUser(resObject.user);
          const person = {
            email: resObject.user.emails[0].value,
            password: resObject.pass,
          };
          console.log(person);

          await loginUser(person)
          .then((req, res) => {
            const { status, message } = req.data;
            if (status === "failed") {
              setInvalidFlag(true);
            } else {
              localStorage.setItem("token", req.data.token);
              setUserAuth(true);
              navigate("/home");
            }
          })
          .catch((err) => alert("one"));

        })
        .catch((err) => {
          console.log(err);
        });
    };
    setTimeout(getUser,5000)
    

    
  }, []);
  
  // console.log(user)
  
  useEffect(() => {
    if (auth) {
      navigate("/home");
    } else {
      setUserAuth(false);
    }
  }, []);

  return (
    <div className="flex flex-col items-center h-screen dark:bg-[#0d1117] bg-[#FAF7F0] bg-cover">
      {loader && (
        <div className="z-10 absolute flex flex-row items-center justify-center h-screen w-full">
          <Loader />
        </div>
      )}

      <div className="flex mt-16 md:mt-10 ">
        {/* <img src={logo} alt="logo" className="inline w-10 h-10" /> */}
        <h1 className="text-4xl sm:text-2xl md:text-4xl cursor-pointer pl-0 font-bold bg-clip-text text-[#c9d1d9]">
        <span className="inline-block text-[#3B7BD3] dark:text-[#FAF7F0]">
    JAL SURA
    <span className="text-red-600">
      क
    </span>
    SHA
  </span>
        </h1>
      </div>
      {invalidflag && (
        <div class="alert alert-danger" role="alert">
          Invalid Login Credentials
        </div>
      )}

      <form
        onSubmit={login}
        className="p-6 dark:bg-[#161b22] bg-[#c3d5ee] h-full flex flex-col items-start drop-shadow-2xl mt-16 md:mt-12 w-5/6 sm:w-1/2 lg:w-1/3 rounded-xl shadow-2xl"
      >
        <h2 className=" text-[#161b22]  dark:text-[#FAF7F0] font-semibold mb-4 text-2xl self-center">
          LOGIN
        </h2>
        <TextBox
          textInput="text-md text-gray-500"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Email ID"
          position="left-2 md:left-3 top-2.5"
          border="border-[#161b22] border-2"
          span="px-1"
          input="px-3 md:px-4"
          div="mt-8"
          setState={setEmail}
          value={email}
          type="email"
        />
        <TextBox
          textInput="text-md text-[#c9d1d9]"
          textLabel="text-md text-gray-500"
          width="w-full"
          height="h-12"
          hint="Password"
          backgroundColor="bg-[#0d1117]"
          position="left-2 md:left-3 top-2.5"
          border="border-[#0d1117] border-2"
          span="px-1"
          input="px-3 md:px-4"
          div="mt-8"
          type="password"
          setState={setPassword}
          value={password}
        />
        <button
          type="submit"
          className="shadow-none w-full text-[#161b22]  dark:text-[#FAF7F0] bg-[#3B7BD3] hover:bg-[#699be2] font-bold py-2 px-4  rounded-xl h-10  my-4"
        >
          Continue
        </button>
        {/* Google Authentication */}
        <div className="text-[#d7dfe7] text-lg  text-center w-full ">Or</div>
        <button
          type="button"
          onClick={gauth}
          className="shadow-none w-full text-gray-800 bg-slate-300 font-bold px-4 hover:bg-slate-50 rounded-xl h-10  my-4"
        >
          <div className="mr-6 flex justify-center items-center">
          <img src="https://icon-library.com/images/google-icon-library/google-icon-library-25.jpg" alt="" width="30px" className="inline-block mr-4"/>
          Sign up with google
          </div>
        </button>

        {/* Google Authentication end */}

        <h1 className="text-[#161b22]  dark:text-[#FAF7F0] text-sm text-left mx-1">
          By continuing, you agree to Jal Suraksha's privacy notice and conditions of
          use.
        </h1>
      </form>
      <div className="mt-8 text-xs md:text-sm sm:w-1/2 lg:w-full flex items-center w-full md:px-1 px-9">
        <hr className="border-t w-full border-[#d7dfe7] flex-grow" />
        <span className=" text-[#161b22]  dark:text-[#FAF7F0] w-full mb-4">New to JAL SURAकSHA?</span>
        <hr className="border-t w-full border-[#d7dfe7] flex-grow" />
      </div>
      <button
        onClick={() => navigate("/register")}
        className=" shadow-none w-82 text-[#161b22]  dark:text-[#FAF7F0] bg-[#3B7BD3] hover:bg-[#699be2] font-bold py-2 px-4 rounded-xl h-10"
      >
        Create your JAL SURAकSHA account
      </button>
      <div className=" bottom-0  dark:bg-[#0D1117] bg-[#FAF7F0] backdrop-filter backdrop-blur-lg flex flex-col items-center w-full h-10 p-4 text-sm ">
        <span className="text-[#161b22]  dark:text-[#FAF7F0]">JAL SURAकSHA | All rights reserved</span>
      </div>
    </div>
  );
};

export default Login;
